import {styled} from "@mui/material/styles"
import {Typography} from "@mui/material"

type PriceLabelProps = {
    isSalePrice?: boolean
}

export const Container = styled("div")`
    display: flex;
    flex-direction: column;
    margin-bottom: 0.375rem;
`

export const PriceRowContainer = styled(Typography)`
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    text-decoration: none;
    font-size: 0.875rem;
    line-height: 1.313;

    &:hover {
        text-decoration: underline;
    }
`

export const PriceLabel = styled("div")<PriceLabelProps>`
    flex: ${props => (props.isSalePrice ? "1 0 0" : "auto")};
    order: ${props => (props.isSalePrice ? "1" : "initial")};
    font-family: ${({theme}) => `${theme.colours.font.primary.regular.family}, ${theme.colours.font.default}`};
    letter-spacing: 0.008rem;
    text-transform: capitalize;
`

export const PriceValue = styled("div")`
    font-family: ${({theme}) => `${theme.colours.font.primary.medium.family}, ${theme.colours.font.default}`};
    font-weight: ${({theme}) => theme.colours.font.primary.medium.weight};
    letter-spacing: 0.008rem;
    display: inline-block;
    min-height: 1.4rem;
    white-space: nowrap;
`

export const PriceContainer = styled("span")`
    text-align: right;
    display: flex;
    flex-direction: column;
`
interface PriceValueProps {
    $brandedMarkdownSalePrice?: boolean
}
export const WasPriceValue = styled(PriceValue)<PriceValueProps>`
    flex: 1 0 0;
    order: 2;
    text-decoration: line-through;
    text-align: right;
`
export const SalePriceValue = styled(PriceValue, {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})<PriceValueProps>`
    color: ${({$brandedMarkdownSalePrice, theme}) =>
        $brandedMarkdownSalePrice
            ? theme.colours.brand.markdown.default.textColor
            : theme.colours.brand.sale.default.textColor};
    flex: 1 100%;
    order: 3;
    font-size: 0.875rem;
    text-align: right;
`
